import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { formatDistanceToNow } from "date-fns";
import { Activity } from "@/services/admin-dashboard.service";
import { formatCurrency } from "@/lib/currency";

interface RecentActivityFeedProps {
  activities: Activity[];
}

export function RecentActivityFeed({ activities }: RecentActivityFeedProps) {
  // Handle undefined or empty activities
  if (!activities || activities.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Recent Activity</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex h-[200px] items-center justify-center text-muted-foreground">
            No recent activity
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Recent Activity</CardTitle>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-[400px]">
          <div className="space-y-4">
            {activities.map((activity) => (
              <div
                key={activity.id}
                className="flex gap-4 border-b pb-4 last:border-0"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium">{activity.type}</span>
                    <span
                      className={`rounded-full px-2 py-0.5 text-xs ${
                        activity.status === "Running"
                          ? "bg-ok-soft text-ok-ink"
                          : activity.status === "Error"
                            ? "bg-destructive-soft text-destructive-ink"
                            : activity.status === "Provisioning"
                              ? "bg-info-soft text-info-ink"
                              : "bg-secondary text-muted-foreground"
                      }`}
                    >
                      {activity.status}
                    </span>
                  </div>
                  <p className="text-xs text-muted-foreground">
                    {activity.description}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    Tenant: {activity.tenantName}
                  </p>
                  {activity.amount && (
                    <p className="text-xs font-medium">
                      {formatCurrency(activity.amount, "VND")}
                    </p>
                  )}
                </div>
                <div className="text-xs text-muted-foreground">
                  {formatDistanceToNow(new Date(activity.timestamp), {
                    addSuffix: true,
                  })}
                </div>
              </div>
            ))}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
